import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot,Resolve,RouterStateSnapshot,Routes} from '@angular/router';
import {JhiResolvePagingParams} from 'ng-jhipster';
import {Observable} from 'rxjs';
import {UserRouteAccessService} from 'src/app/core';
import {RuleMySuffix} from 'src/app/shared/model/rule-my-suffix.model';
import {RuleMySuffixDeletePopupComponent} from './rule-my-suffix-delete-dialog.component';
import {RuleMySuffixDetailComponent} from './rule-my-suffix-detail.component';
import {RuleMySuffixUpdateComponent} from './rule-my-suffix-update.component';
import {RuleMySuffixComponent} from './rule-my-suffix.component';
import {RuleMySuffixService} from './rule-my-suffix.service';

@Injectable({ providedIn: 'root' })
export class RuleMySuffixResolve implements Resolve<any> {
    constructor(private service: RuleMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            if (state.url.includes('edit')) {
                return this.service.findForEdit(id).map((rule: HttpResponse<RuleMySuffix>) => rule.body);
            }
            return this.service.find(id).map((rule: HttpResponse<RuleMySuffix>) => rule);
        }
        return Observable.of(new RuleMySuffix());
    }
}

export const ruleRoute: Routes = [
    {
        path: '',
        component: RuleMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:scopeId/view',
        component: RuleMySuffixDetailComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:scopeId/view/ots',
        component: RuleMySuffixDetailComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'open-policy-rule-my-suffix/:id/:scopeId/view',
        component: RuleMySuffixDetailComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: ['BROKER',
            'BROKER_STAFF','UNDERWRITER', 'UNDERWRITER_STAFF', 'INSURER', 'INSURER_STAFF'],
            pageTitle: 'OpenRules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:scopeId',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'ots/:scopeId',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:scopeId/edit',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:scopeId/ots/edit',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'new/:scopeId/:ots/:crId',
        component: RuleMySuffixUpdateComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: ':id/:scopeId/ots/view',
        component: RuleMySuffixDetailComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'AUDIT_USER_STAFF',
                'AUDIT_USER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF',
                'INSURER_AUDIT',
                'UNDERWRITER_AUDIT'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const rulePopupRoute: Routes = [
    {
        path: ':id/delete',
        component: RuleMySuffixDeletePopupComponent,
        resolve: {
            rule: RuleMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'Rules'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
